"use client";

import React, { useState, useEffect, useMemo } from "react";
import { Image, Toast } from 'antd-mobile'
import { useTranslation } from "react-i18next";
import styles from "./LoginModal.module.less";
import { actionTypes, useStoreDispatch } from '@/store'
import { useSelectRole } from '@/hooks/useSelectRole'
// import {
//   useGameInfoInit,
//   useIsMobile,
//   usePlatformConfig,
//   useUserLoginActions,
//   useInitInfo,
//   useServerRoleModal,
//   useUserServerRole,
//   useFooterProtocolLinks,
// } from "@/contexts/AppContext";
// import { getUserInfo, mutationFetcher, getThirdPartyLoginUrl, getGameInfoNew } from "@/request/client/clientApi";
// import useSWRMutation from "swr/mutation";
// import { md5 } from "js-md5";
// import {
//   PlatformApiResponse,
//   PlatformLogin,
//   LoginType,
//   UserInfo,
// } from "@/type/api";
// import { getLocalStorageItem, setLocalStorageItem } from "@/utils/clientUtils";
import Modal from "@/components/common/Modal";
import { getTokenApi, login } from "@/api/user";
// import toast from "react-hot-toast";
// import { useFacebookAuth } from "@/hooks/useFacebookAuth";
// import { useGoogleAuth } from "@/hooks/useGoogleAuth";
// import { h5EventSDKManager } from "@/utils/h5EventSDK";
// import HelpModal from "./HelpModal";
// import { common } from "@/static";

export interface LoginModalProps {
  /** 是否显示弹窗 */
  isOpen: boolean;
  /** 关闭弹窗回调 */
  onClose: () => void;
  /** 自定义类名 */
  className?: string;
}

const LoginModal: React.FC<LoginModalProps> = ({
  isOpen,
  onClose,
  className,
}) => {
  const { t } = useTranslation();
  const dispatch = useStoreDispatch();
  const [getRoles] = useSelectRole();
  // const platformConfig = usePlatformConfig();
  // const footerProtocolLinks = useFooterProtocolLinks();

  // 当前弹窗需要的数据控制
  const [selectedLoginType, setSelectedLoginType] =
    useState<string>('account');
  const [formData, setFormData] = useState({
    account: "",
    platform: "",
    password: "",
    accountId: "",
    inheritance_code: "",
  });
  // const { updateUserLoginState } = useUserLoginActions();
  const [loading, setLoading] = useState(false);
  const [isAgreementChecked, setIsAgreementChecked] = useState(false);
  const [helpModal, setHelpModal] = useState({
    isOpen: false,
    content: ""
  });

  const getToken = async model => {
    setLoading(true)
    const res = await getTokenApi(model).finally(() => setLoading(false))
    if (res?.code === 0) {
      Toast.show({ icon: 'success', content: `${t('user-center.login.login-tips')}` });
      localStorage.setItem('token', res.data.token);
      dispatch({ type: actionTypes.SET_USER, payload: { isLogin: true } });
      resetForm();
      // 海外登录成功后自动选择角色（与国内登录逻辑保持一致）
      // getRoles() 会自动选择第一个角色，并跳转到首页刷新页面
      getRoles();
    }
    return res
  }

  // const { updateUserServer, updateUserRole } = useUserServerRole();

  // 通用的登录后处理函数
  // const handleLoginSuccess = async (userInfo: any, token: string, loginType: string) => {
  //   // 上报登录成功埋点
  //   // try {
  //   //   h5EventSDKManager.reportEvent({
  //   //     action: 'gamermall_click#login',
  //   //     status: 200,
  //   //     event: loginType,
  //   //     uid: userInfo.openId || ''
  //   //   });
  //   // } catch (error) {
  //   //   console.warn('埋点上报失败:', error);
  //   // }

  //   // 保存登录信息到localStorage
  //   // setLocalStorageItem(platformConfig.platform, "token", token);
  //   // setLocalStorageItem(platformConfig.platform, "userInfo", JSON.stringify(userInfo));

  //   // 更新顶层的用户登录状态
  //   // updateUserLoginState({
  //   //   isLoggedIn: true,
  //   //   userInfo,
  //   //   token,
  //   // });

  //   // 检查localStorage中是否存在userServer和userRole
  //   // const userServer = getLocalStorageItem(platformConfig.platform, "userServer");
  //   // const userRole = getLocalStorageItem(platformConfig.platform, "userRole");

  //   // 登录成功，关闭弹窗并重置表单
  //   resetForm();
  //   onClose();

  //   // // 如果userServer或userRole不存在，显示服务器角色选择器
  //   // if (!userServer || !userRole) {
  //   //   showServerRoleSelector();
  //   // } else {
  //   //   // 将localStorage中的userServer和userRole转换为对象
  //   //   const userServerObj = JSON.parse(userServer);
  //   //   const userRoleObj = JSON.parse(userRole);
  //   //   // 更新userServer和userRole
  //   //   updateUserServer(userServerObj);
  //   //   updateUserRole(userRoleObj);
  //   // }
  // };

  // const gameInfo = useGameInfoInit();
  // const isMobile = useIsMobile();
  // const initInfo = useInitInfo();
  // const { showServerRoleSelector } = useServerRoleModal();

  // const { trigger: loginTrigger } = useSWRMutation(
  //   `${process.env.NEXT_PUBLIC_LOGIN_HOST}/user/p/login`,
  //   mutationFetcher,
  //   { populateCache: false }
  // ) as {
  //   trigger: (
  //     arg: Record<string, string | number>
  //   ) => Promise<PlatformApiResponse<PlatformLogin>>;
  // };

  // // Facebook登录相关
  // const {
  //   startFacebookLogin,
  //   authState,
  //   retryFacebookLogin,
  //   isConfigured: facebookConfigured,
  //   canRetry: facebookCanRetry
  // } = useFacebookAuth({
  //   onSuccess: async (userInfo, token) => {
  //     try {
  //       await handleLoginSuccess(userInfo, token, 'facebook');
  //       toast.success(t('login.success'));
  //     } catch (error) {
  //       console.error("Facebook登录后处理失败:", error);
  //       toast.error(t('login.failed'));
  //     }
  //   },
  //   onError: (error) => {
  //     console.error("Facebook登录失败:", error);
  //     toast.error(t('login.failed'));
  //     // 上报登录失败埋点
  //     try {
  //       h5EventSDKManager.reportEvent({
  //         action: 'gamermall_click#login',
  //         status: 100,
  //         event: 'facebook',
  //       });
  //     } catch (reportError) {
  //       console.warn('埋点上报失败:', reportError);
  //     }
  //   }
  // });
  // const facebookLoading = authState.isLoading;

  // // Google登录相关
  // const {
  //   startGoogleLogin,
  //   authState: googleAuthState,
  //   retryGoogleLogin,
  //   isConfigured: googleConfigured,
  //   canRetry: googleCanRetry
  // } = useGoogleAuth({
  //   onSuccess: async (userInfo, token) => {
  //     try {
  //       await handleLoginSuccess(userInfo, token || '', 'google');
  //       toast.success(t('login.success'));
  //     } catch (error) {
  //       console.error("Google登录后处理失败:", error);
  //       toast.error(t('login.failed'));
  //     }
  //   },
  //   onError: (error) => {
  //     console.error("Google登录失败:", error);
  //     toast.error(t('login.failed'));
  //     // 上报登录失败埋点
  //     try {
  //       h5EventSDKManager.reportEvent({
  //         action: 'gamermall_click#login',
  //         status: 100,
  //         event: 'google',
  //       });
  //     } catch (reportError) {
  //       console.warn('埋点上报失败:', reportError);
  //     }
  //   }
  // });

  // const googleLoading = googleAuthState.isLoading;

  // 处理登录方式选择
  // const handleLoginTypeSelect = async (loginType: LoginType) => {
  //   const formSupportedTypes = ["account", "platform", "inheritance_code"];

  //   if (formSupportedTypes.includes(loginType.loginType)) {
  //     // 如果点击的是当前已选中的登录方式，则不执行任何操作
  //     if (selectedLoginType === loginType.loginType) {
  //       return;
  //     }
  //     // 如果是支持表单的登录方式，则显示对应表单
  //     setSelectedLoginType(loginType.loginType);
  //     resetForm();
  //   } else if (loginType.loginType === "facebook") {
  //     // Facebook登录1：点击Facebook登录图标
  //     try {
  //       // Facebook登录2：判断Facebook登陆配置（从初始化信息中获取）
  //       if (!facebookConfigured) {
  //         console.log('Facebook登录配置不完整');
  //         return;
  //       }

  //       // Facebook登录3：判断当前Facebook登录状态
  //       if (authState.status === 'error' && facebookCanRetry) {
  //         console.log('重试Facebook登录');
  //         retryFacebookLogin();
  //       } else {
  //         console.log('开始Facebook登录');
  //         await startFacebookLogin();
  //       }
  //     } catch (error) {
  //       // Facebook登录4：处理登录失败
  //       console.error("启动Facebook登录失败:", error);

  //       // 上报登录失败埋点
  //       try {
  //         h5EventSDKManager.reportEvent({
  //           action: 'gamermall_click#login',
  //           status: 500,
  //           event: 'facebook',
  //           uid: '',
  //           error_code: 'startup_failed',
  //           error_message: '启动Facebook登录失败'
  //         });
  //       } catch (reportError) {
  //         console.warn('埋点上报失败:', reportError);
  //       }
  //     }
  //   } else if (loginType.loginType === "google") {
  //     // Google登录1：点击Google登录图标
  //     try {
  //       // Google登录2：判断Google登陆配置（从初始化信息中获取）
  //       if (!googleConfigured) {
  //         console.log('Google登录配置不完整');
  //         return;
  //       }

  //       // Google登录3：判断当前Google登录状态
  //       if (googleAuthState.status === 'error' && googleCanRetry) {
  //         console.log('重试Google登录');
  //         retryGoogleLogin();
  //       } else {
  //         console.log('开始Google登录');
  //         await startGoogleLogin();
  //       }
  //     } catch (error) {
  //       // Google登录4：处理登录失败
  //       console.error("启动Google登录失败:", error);

  //       // 上报登录失败埋点
  //       try {
  //         h5EventSDKManager.reportEvent({
  //           action: 'gamermall_click#login',
  //           status: 500,
  //           event: 'google',
  //           uid: '',
  //           error_code: 'startup_failed',
  //           error_message: '启动Google登录失败'
  //         });
  //       } catch (reportError) {
  //         console.warn('埋点上报失败:', reportError);
  //       }

  //     }
  //   } else if (["line", "apple", "naver"].includes(loginType.loginType)) {
  //     // Line、Apple、Naver第三方登录
  //     try {
  //       const response = await getThirdPartyLoginUrl({
  //         platform: platformConfig.platform,
  //         loginType: loginType.loginType,
  //         redirectUri: window.location.origin + window.location.pathname + '?loginType=' + loginType.loginType,
  //       });

  //       if (response.data.url) {
  //         // 跳转到第三方登录页面
  //         window.location.href = response.data.url;
  //       } else {
  //         toast.error(t('login.failed'));
  //       }
  //     } catch (error) {
  //       console.error(`${loginType.loginType}登录失败:`, error);

  //       // 上报登录失败埋点
  //       try {
  //         h5EventSDKManager.reportEvent({
  //           action: 'gamermall_click#login',
  //           status: 500,
  //           event: loginType.loginType,
  //           uid: '',
  //           error_code: 'third_party_failed',
  //           error_message: `${loginType.loginType}登录失败`
  //         });
  //       } catch (reportError) {
  //         console.warn('埋点上报失败:', reportError);
  //       }
  //     }
  //   } else {
  //     // 其他未支持的登录方式
  //     toast.error(t('login.unsupported'));
  //   }
  // };

  // 点击登录按钮(有表单才有)
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // 检查隐私协议是否已勾选
    // if (!isAgreementChecked) {
    //   toast(t('login.agreement.required'));
    //   return;
    // }
    // // 检查数据合法性
    // if (!selectedLoginType) {
    //   toast(t('login.type.required'));
    //   return;
    // }
    // // 验证不同登录方式的必填字段
    if (selectedLoginType === "account") {
      if (!formData.account.trim()) {
        Toast.show({ icon: 'fail', content: t('user-center.login.requiredAccountID') });
        return;
      }
    }
    // } else if (selectedLoginType === "platform") {
    //   if (!formData.platform.trim() || !formData.password.trim()) {
    //     toast(t('login.form.requiredEmail'));
    //     return;
    //   }
    // } else if (selectedLoginType === "inheritance_code") {
    //   if (!formData.accountId.trim() || !formData.inheritance_code.trim()) {
    //     toast(t('login.form.requiredInheritanceCode'));
    //     return;
    //   }
    // }

    setLoading(true);
    const res = await login({
      account: formData.account,
      type: 7,
    }).finally(() => setLoading(false))
    if (res?.code === 0) {
      res.data.userVos.map(option => {
        option.token = res.data.token
      })
      getToken(res.data.userVos[0])
    }
    // try {
    //   let account: string;
    //   let password: string;

    //   // 根据登录方式构建不同的登录参数
    //   if (selectedLoginType === "account") {
    //     account = formData.account;
    //     password = ""; // 用户ID登录可能不需要密码
    //   } else if (selectedLoginType === "platform") {
    //     account = formData.platform;
    //     password = md5(formData.password);
    //   } else if (selectedLoginType === "inheritance_code") {
    //     account = formData.accountId;
    //     password = formData.inheritance_code; // 引继码作为密码
    //   } else {
    //     toast(t('login.unsupported'));
    //     return;
    //   }

    //   const loginParams = {
    //     source: platformConfig.platform,
    //     sourceType: isMobile,
    //     account,
    //     password,
    //     loginType: selectedLoginType,
    //   };

    //   let userInfoResponse;
      
    //   if (selectedLoginType === 'account') {
    //     // 用户名登录方式直接调用getUserInfo，不需要先调用登录接口
    //     userInfoResponse = await getUserInfo({
    //       platform: platformConfig.platform,
    //       uid: account,
    //       uname: account,
    //       loginType: selectedLoginType,
    //       appid: gameInfo.appId,
    //     });
    //   } else if (selectedLoginType === 'inheritance_code') {
    //     // 引继码登录方式直接调用getUserInfo，不需要先调用登录接口
    //     userInfoResponse = await getUserInfo({
    //       inheritancecode: formData.inheritance_code,
    //       platform: platformConfig.platform,
    //       uid: account,
    //       uname: account,
    //       loginType: selectedLoginType,
    //       appid: gameInfo.appId,
    //     });
    //   } else {
    //     // 其他登录方式需要先调用平台登录接口获取token，再调用getUserInfo
    //     const loginInfo: PlatformApiResponse<PlatformLogin> = await loginTrigger(
    //       loginParams
    //     );
    //     const { token } = loginInfo.data;

    //     // 拿到accessToken后请求用户信息
    //     userInfoResponse = await getUserInfo({
    //       platform: platformConfig.platform,
    //       accessToken: token,
    //       uid: account,
    //       uname: account,
    //       loginType: selectedLoginType,
    //       appid: gameInfo.appId,
    //     });
    //   }

    //   // 登录信息获取成功后还要去调用400102获取对应的openId
    //   const gameInfoResponse = await getGameInfoNew({
    //     platform: platformConfig.platform,
    //     token: userInfoResponse.data.token,
    //   })
      
    //   // 检查 gameInfoResponse 是否有效
    //   if (!gameInfoResponse?.data || !gameInfoResponse.data.openId) {
    //     throw new Error("获取游戏信息失败或openId为空");
    //   }
      
    //   userInfoResponse.data.openId = gameInfoResponse.data.openId;
    //   // 在本地记录登录态并处理登录后逻辑
    //   if (userInfoResponse.data.token) {
    //     await handleLoginSuccess(userInfoResponse.data, userInfoResponse.data.token, selectedLoginType);
    //   }
    // } catch (error) {
    //   console.error("表单登录失败:", error);

    //   // 上报登录失败埋点
    //   try {
    //     h5EventSDKManager.reportEvent({
    //       action: 'gamermall_click#login',
    //       status: 100,
    //       login_type: selectedLoginType
    //     });
    //   } catch (reportError) {
    //     console.warn('埋点上报失败:', reportError);
    //   }

    //   toast(t('login.failed'));
    // } finally {
    //   setLoading(false);
    // }
  };

  // 重置表单
  const resetForm = () => {
    setFormData({
      account: "",
      platform: "",
      password: "",
      accountId: "",
      inheritance_code: "",
    });
  };

  // 更新表单数据
  const updateFormData = (field: string, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  // // 获取启用的登录方式
  // const enabledLoginTypes = useMemo(() => 
  //   initInfo?.loginTypes?.filter((type) => type.enable === 1) || []
  // , [initInfo]);

  // // 自动选中第一个支持表单的登录方式
  // useEffect(() => {
  //   if (enabledLoginTypes.length > 0 && !selectedLoginType) {
  //     const formSupportedTypes = ["account", "platform", "inheritance_code"];
  //     const firstFormLoginType = enabledLoginTypes.find(type => 
  //       formSupportedTypes.includes(type.loginType)
  //     );
      
  //     if (firstFormLoginType) {
  //       console.log(firstFormLoginType.loginType)
  //       setSelectedLoginType(firstFormLoginType.loginType);
  //     }
  //   }
  // }, [enabledLoginTypes, selectedLoginType]);

  // 获取登录方式的图标和文案配置
  // const getLoginTypeConfig = (loginType: string) => {
  //   const loginTypeConfigs: Record<string, { icon: StaticImageData; label: string }> = {
  //     account: {
  //       icon: common.account,
  //       label: t('login.type.account'),
  //     },
  //     platform: {
  //       icon: common.email,
  //       label: t('login.type.email'),
  //     },
  //     inheritance_code: {
  //       icon: common.account,
  //       label: t('login.type.inheritanceCode'),
  //     },
  //     facebook: {
  //       icon: common.facebook,
  //       label: "Facebook",
  //     },
  //     google: {
  //       icon: common.google,
  //       label: "Google",
  //     },
  //     apple: {
  //       icon: common.apple,
  //       label: "Apple",
  //     },
  //     line: {
  //       icon: common.line,
  //       label: "LINE",
  //     },
  //     naver: {
  //       icon: common.naver,
  //       label: "Naver",
  //     },
  //   };

  //   return (
  //     loginTypeConfigs[loginType] || {
  //       icon: "/images/common/account.png",
  //       label: loginType,
  //     }
  //   );
  // };

  // // 渲染登录方式选择按钮
  // const renderLoginTypeButtons = () => {
  //   // 过滤掉当前已选中的登录方式
  //   const availableLoginTypes = enabledLoginTypes.filter(
  //     (type) => type.loginType !== selectedLoginType
  //   );

  //   return (
  //     <div className={styles.loginTypeButtons}>
  //       {availableLoginTypes.map((type) => {
  //         const config = getLoginTypeConfig(type.loginType);
  //         return (
  //           <button
  //             key={type.loginType}
  //             type="button"
  //             className={styles.loginTypeButton}
  //             onClick={() => handleLoginTypeSelect(type)}
  //             disabled={loading || facebookLoading || googleLoading}
  //           >
  //             <Image
  //               src={config.icon}
  //               alt={config.label}
  //               className={styles.loginTypeIcon}
  //               loading="eager"
  //               width={24}
  //               height={24}
  //               priority
  //             />
  //             <span>{config.label}</span>
  //           </button>
  //         );
  //       })}
  //     </div>
  //   );
  // };

  // 渲染表单输入字段
  const renderFormFields = () => {
    if (!selectedLoginType) return null;

    switch (selectedLoginType) {
      case "account":
        return (
          <>
            <div className={styles.formGroup}>
              <input
                id="account"
                type="text"
                className={styles.input}
                value={formData.account}
                onChange={(e) => updateFormData("account", e.target.value)}
                placeholder={t('user-center.login.account-id')}
                disabled={loading}
              />
            </div>
            {/* <div
              className={styles.helpText}
              onClick={() => {
                const currentLoginType = initInfo?.loginTypes?.find(type => type.loginType === selectedLoginType);
                if (currentLoginType?.loginDescribe) {
                  setHelpModal({
                    isOpen: true,
                    content: currentLoginType.loginDescribe
                  });
                }
              }}
            >
              {t('login.help.userId')}
            </div> */}
          </>
        );

      case "platform":
        return (
          <>
            <div className={styles.formGroup}>
              <input
                id="platform"
                type="email"
                className={styles.input}
                value={formData.platform}
                onChange={(e) => updateFormData("platform", e.target.value)}
                placeholder={t('login.placeholder.email')}
                disabled={loading}
              />
            </div>
            <div className={styles.formGroup}>
              <input
                id="password"
                type="password"
                className={styles.input}
                value={formData.password}
                onChange={(e) => updateFormData("password", e.target.value)}
                placeholder={t('login.placeholder.password')}
                disabled={loading}
              />
            </div>
            {/* <div
              className={styles.helpText}
              onClick={() => {
                const currentLoginType = initInfo?.loginTypes?.find(type => type.loginType === selectedLoginType);
                if (currentLoginType?.loginDescribe) {
                  setHelpModal({
                    isOpen: true,
                    content: currentLoginType.loginDescribe
                  });
                }
              }}
            >
              {t('login.help.email')}
            </div> */}
          </>
        );

      case "inheritance_code":
        return (
          <>
            <div className={styles.formGroup}>
              <input
                id="accountId"
                type="text"
                className={styles.input}
                value={formData.accountId}
                onChange={(e) => updateFormData("accountId", e.target.value)}
                placeholder={t('login.placeholder.accountId')}
                disabled={loading}
              />
            </div>
            <div className={styles.formGroup}>
              <input
                id="inheritance_code"
                type="text"
                className={styles.input}
                value={formData.inheritance_code}
                onChange={(e) =>
                  updateFormData("inheritance_code", e.target.value)
                }
                placeholder={t('login.placeholder.inheritanceCode')}
                disabled={loading}
              />
            </div>
            {/* <div
              className={styles.helpText}
              onClick={() => {
                const currentLoginType = initInfo?.loginTypes?.find(type => type.loginType === selectedLoginType);
                if (currentLoginType?.loginDescribe) {
                  setHelpModal({
                    isOpen: true,
                    content: currentLoginType.loginDescribe
                  });
                }
              }}
            >
              {t('login.help.inheritanceCode')}
            </div> */}
          </>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={handleClose}
        title={t('user-center.login.title')}
        className={className}
        contentClassName={styles.loginModalContent}
        closeOnOverlayClick={false}
      >
        <div className={styles.loginContainer}>
          {/* 表单区域 */}
          {selectedLoginType && (
            <form className={styles.loginForm} onSubmit={handleSubmit}>
              {renderFormFields()}

              {/* <div className={styles.agreementSection}>
                <label
                  className={styles.agreementLabel}
                  onClick={() => setIsAgreementChecked(!isAgreementChecked)}
                >
                  <Image
                    src={
                      isAgreementChecked
                        ? common.checked
                        : common.uncheck
                    }
                    alt={isAgreementChecked ? "checked" : "unchecked"}
                    width={16}
                    height={16}
                    className={styles.agreementCheckbox}
                  />
                  <span>
                    {t('login.agreement.text')}{" "}
                    <span
                      className={styles.agreementLink}
                      onClick={(e) => {
                        e.stopPropagation();
                        const termsUrl = footerProtocolLinks['4'];
                        window.open(termsUrl, '_blank');
                      }}
                    >
                      {t('login.agreement.terms')}
                    </span>{" "}
                    <span
                      className={styles.agreementLink}
                      onClick={(e) => {
                        e.stopPropagation();
                        const privacyUrl = footerProtocolLinks['7'];
                        window.open(privacyUrl, '_blank');
                      }}
                    >
                      {t('login.agreement.privacy')}
                    </span>
                  </span>
                </label>
              </div> */}

              <button
                type="submit"
                className={styles.submitButton}
                disabled={loading}
              >
                {loading ? t('user-center.login.loading') : t('user-center.login.submit')}
              </button>
            </form>
          )}

          {/* 登录方式按钮 */}
          {/* {renderLoginTypeButtons()} */}
        </div>
      </Modal>

      {/* <HelpModal
        isOpen={helpModal.isOpen}
        onClose={() => setHelpModal({ isOpen: false, content: "" })}
        content={helpModal.content}
      /> */}
    </>
  );
};

export default LoginModal;
